<template>
    <section class="pt-24 bgcc-riba">
      <div class="container pb-20 mx-auto text-center">
       <div class="px-4 lg:mx-36">
          <h2 class="mb-2 font-semibold leading-tight text-gray-800 capitalize text-1xl">
            <br>
            <span ref="fundingInProgress" class="cursor-pointer" @click="retreiveProject(true)">กำลังระดมทุน</span> 
            |
            <span ref="cloasedFunding" class="cursor-pointer" @click="retreiveProject(false)">ปิดระดมทุน</span>
          </h2>
          <br>
          <div class="flex flex-wrap justify-around ">
            <div class="flex items-center cursor-pointer lg:flex-row sm:flex-col" @click="selectCategory('all')">
              <i class="ml-4 sm:text-1xl lg:text-4xl text-emerald-700 fas fa-border-all"></i>
              <p class="ml-2 text-sm text-left ">หมวดหมู่ทั้งหมด</p>
            </div>
            <div class="flex items-center cursor-pointer lg:flex-row sm:flex-col" @click="selectCategory(3)">
              <i class="mb-4 ml-4 sm:text-1xl lg:text-4xl text-emerald-700 fa-school fas"></i>
              <p class="ml-2 text-sm text-left ">การศึกษา</p>
            </div>
            <div class="flex items-center cursor-pointer lg:flex-row sm:flex-col" @click="selectCategory(4)">
              <i class="mb-4 ml-4 sm:text-1xl lg:text-4xl text-emerald-700 fa-retweet fas"></i>
              <p class="ml-2 text-sm text-left ">ศาสนาและสังคม</p>
            </div>
            <div class="flex items-center cursor-pointer lg:flex-row sm:flex-col" @click="selectCategory(5)">
              <i class="mb-4 ml-4 sm:text-1xl lg:text-4xl text-emerald-700 fa-water fas"></i>
              <p class="ml-2 text-sm text-left ">ภัยพิบัติ</p>
            </div>
            <div class="flex items-center cursor-pointer lg:flex-row sm:flex-col" @click="selectCategory(6)">
              <i class="mb-4 ml-4 sm:text-1xl lg:text-4xl text-emerald-700 fa-heartbeat fas"></i>
              <p class="ml-2 text-sm text-left ">สุขภาพและการแพทย์</p>
            </div>
            <div class="flex items-center cursor-pointer lg:flex-row sm:flex-col" @click="selectCategory(7)">
              <i class="mb-4 sm:text-1xl lg:text-4xl text-emerald-700 fa-balance-scale fas"></i>
              <p class="ml-2 text-sm text-left ">กระบวนการยุติธรรม</p>
            </div>

          </div>
       </div>
       <br>
        <div class="flex flex-wrap items-center">
            <div v-for="(item, index) in projects" :key="index" class="w-full p-4 lg:w-4/12 sm:w-6/12">
              <router-link :to="{name: 'ProjectDetail', params:{id: item.id}}">
                <a aria-current="page" href="/projects" class="block text-left router-link-active router-link-exact-active">
                  <img :src="item.image" alt="" class="object-fill rounded-t-lg" style="width: 490px; height: 350px; object-fit: cover;">
                </a>
              </router-link>
              <div class="p-6 bg-white shadow-lg">
                <router-link :to="{name: 'ProjectDetail', params:{id: item.id}}">
                  <h5 class="mb-2 text-xl font-medium text-left text-blue-900">
                    <!-- {{item.name.substring(0,100)+"..."}} -->
                    {{ item.name }}
                  </h5>
                </router-link>
              <p class="mb-4 text-base text-left text-gray-700">
                <span class="font-semibold">ผู้เสนอโครงการ : </span> {{ item.organization }}
              </p>
              <div class="flex justify-between">
                <div class="text-sm">ระดมทุนได้แล้ว</div>
                <div class="text-sm">เป้าหมาย</div>
              </div>
              <div class="flex justify-between mt-2">
                <div class="text-sm">{{showMoney(item.totalSuccess.total)}} ({{showMoney(item.persent)}}%)</div>
                <div>{{showMoney(item.budget)}}</div>
              </div>
              <div class="w-full bg-gray-200 rounded-full">
                <div class="bg-yellow-400 text-xs h-2 font-medium text-blue-100 text-center p-0.5 leading-none rounded-l-full" :style="`width: ${item.persent}%`"></div>
              </div> 
              
              <div class="flex justify-between mt-2">
                <div class="text-sm">เหลือ {{item.dayRemaining}} วัน</div>
                <div class="text-sm">ผู้ร่วมสนับสนุน {{item.totalDonator}} คน</div>
              </div>  
              <br>
              <div class="grid grid-cols-4 gap-4">
                <div class="col-span-2" v-if="item.derma_budget == 11">
                  <button type="button" :disabled="item.project_process == 5" :class="{'opacity-50 cursor-not-allowed': item.project_process == 5}" @click="selectProject(item.id, 1, item.set_amount, item.fee, item.project_id, item.project_process)" class="w-full inline-block px-2 py-2.5 bg-yellow-500 text-white font-medium text-l leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out">
                    บริจาค
                  </button>
                </div>
                <div class="col-span-2" v-if="item.riba_budget == 11">
                  <button type="button" :disabled="item.project_process == 5" :class="{'opacity-50 cursor-not-allowed': item.project_process == 5}" @click="selectProject(item.id, 2, item.set_amount, item.fee, item.project_id, item.project_process)" class="w-full inline-block px-2 py-2.5 bg-orange-600 text-white font-medium text-l leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out">
                    สะสางดอกเบี้ย
                  </button>
                </div>
                <div class="col-span-2" v-if="item.zakat_budget == 11">
                  <button type="button" :disabled="item.project_process == 5" :class="{'opacity-50 cursor-not-allowed': item.project_process == 5}" @click="selectProject(item.id, 3, item.set_amount, item.fee, item.project_id, item.project_process)" class="w-full inline-block px-2 py-2.5 bg-green-600 text-white font-medium text-l leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out">
                    จ่ายซะกาต
                  </button>
                </div>
                <!-- <div class="col-span-2" v-if="!logedIn && item.derma_budget == 11">
                  <button type="button" data-bs-toggle="modal" data-bs-target="#loginAlertModal" class="w-full inline-block px-6 py-2.5 bg-orange-600 text-white font-medium text-l leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out">
                    บริจาค
                  </button>
                </div>
                <div class="col-span-2" v-if="!logedIn && item.zakat_budget == 11">
                  <button type="button" data-bs-toggle="modal" data-bs-target="#loginAlertModal" class="w-full inline-block px-2 py-2.5 bg-green-600 text-white font-medium text-l leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out">
                    จ่ายซะกาต
                  </button>
                </div> -->
                <!-- <div class="col-span-2" v-if="myCart == 0 || !logedIn">
                  <router-link :to="{name: 'ProjectDetail', params:{id: item.id}}">
                    <button type="button" class="w-full inline-block px-6 py-2.5 bg-orange-600 text-white font-medium text-l leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out">
                      บริจาค
                    </button>
                  </router-link>
                </div>
                <div class="col-span-2">
                  <button v-if="logedIn" @click="selectProject(item.id)" type="button"  data-bs-target="#selectMoneyModal" class="w-full inline-block px-2 py-2.5 bg-orange-600 text-white font-medium text-l leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out">
                    <i class="fas fa-shopping-basket"></i> หยิบใส่ตะกร้า
                  </button>
                  <button v-else type="button" data-bs-toggle="modal" data-bs-target="#loginAlertModal" class="w-full inline-block px-6 py-2.5 bg-orange-600 text-white font-medium text-l leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out">
                    <i class="text-l text-white-700 fas fa-shopping-cart"></i>
                  </button>
                </div> -->
              </div>
            </div>
            </div>
        </div>
      </div>
    </section>

    <!-- ฟอร์มระบุจำนวนเงิน -->
    <div class="fixed top-0 left-0 hidden w-full h-full overflow-x-hidden overflow-y-auto outline-none modal fade" :class="[showModal ? ['show','show-modal'] : 'hide-modal'] "  id="selectMoneyModal" tabindex="-1" aria-labelledby="exampleModalCenteredScrollable" aria-modal="true" role="dialog">
      <div class="relative w-auto pointer-events-none modal-dialog-scrollable modal-lg modal-dialog">
        <div class="relative flex flex-col w-full text-current bg-white border-none rounded-md shadow-lg outline-none pointer-events-auto modal-content bg-clip-padding">
          <div class="flex items-center justify-between flex-shrink-0 p-4 border-b border-gray-200 modal-header rounded-t-md">
            <h5 class="text-xl font-medium leading-normal text-gray-800" id="exampleModalCenteredScrollableLabel">
              <span v-if="budget_type == 1">เลือกหรือระบุจำนวนเงินเพื่อบริจาค</span>
              <span v-else-if="budget_type == 2">เลือกหรือระบุจำนวนเงินเพื่อสะสางดกเบี้ย</span>
              <span v-else-if="budget_type == 3">เลือกหรือระบุจำนวนเงินเพื่อจ่ายซะกาต</span>
            </h5>
            <button type="button"
              class="box-content w-1 h-1 p-1 text-black border-none rounded-none opacity-50 btn-close focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              @click="closeModal" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="flex flex-wrap items-center justify-around w-full" v-if="set_amount.length">
                <div class="w-1/2 max-w-sm p-3 mt-1 rounded-lg lg:w-3/12 sm:w-6/12" v-for="(item, index) in set_amount" :key="index"> 
                    <button @click="selectMoney(item.amount)" class="w-full h-24 px-4 py-1 text-2xl font-semibold border border-purple-200 rounded-sm text-black-600 hover:text-white hover:bg-green-600 hover:border-transparent focus:outline-none focus:ring-2 focus:ring-purple-600 focus:ring-offset-2">
                        {{item.name}} <br> 
                        <span class="text-sm">
                          ( {{ showAmount(item.amount) }} บาท )
                        </span>
                    </button>
                </div>
                <div class="max-w-sm p-2 mt-1 rounded-lg lg:w-3/12 sm:w-6/12"> 
                    <button class="w-full h-24 px-4 py-1 font-semibold border border-purple-200 rounded-sm text-l text-black-600 hover:text-white hover:bg-green-600 hover:border-transparent focus:outline-none focus:ring-2 focus:ring-purple-600 focus:ring-offset-2">ระบุจำนวนเงิน
                      <br>
                      <input type="number" v-model="input_money" class="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder=""/>
                    </button>     
                </div>
            </div>
            <div class="flex flex-wrap items-center justify-around w-full" v-else>
              <div class="max-w-sm p-2 mt-1 rounded-lg lg:w-3/12 sm:w-6/12"> 
                <button @click="selectMoney(100)" class="w-40 h-24 px-4 py-1 text-2xl font-semibold border border-purple-200 rounded-sm text-black-600 hover:text-white hover:bg-green-600 hover:border-transparent focus:outline-none focus:ring-2 focus:ring-purple-600 focus:ring-offset-2">
                  100 บาท
                </button>
              </div>
              <div class="max-w-sm p-2 mt-1 rounded-lg lg:w-3/12 sm:w-6/12">
                <button @click="selectMoney(500)" class="w-40 h-24 px-4 py-1 text-2xl font-semibold border border-purple-200 rounded-sm text-black-600 hover:text-white hover:bg-green-600 hover:border-transparent focus:outline-none focus:ring-2 focus:ring-purple-600 focus:ring-offset-2">
                  500 บาท
                </button>
              </div>
              <div class="max-w-sm p-2 mt-1 rounded-lg lg:w-3/12 sm:w-6/12">
                  <button @click="selectMoney(1000)" class="w-40 h-24 px-4 py-1 text-2xl font-semibold border border-purple-200 rounded-sm text-black-600 hover:text-white hover:bg-green-600 hover:border-transparent focus:outline-none focus:ring-2 focus:ring-purple-600 focus:ring-offset-2">
                    1,000 บาท
                  </button>
              </div>
              <div class="max-w-sm p-2 mt-1 rounded-lg lg:w-3/12 sm:w-6/12"> 
                <button class="w-40 h-24 px-4 py-1 font-semibold border border-purple-200 rounded-sm text-l text-black-600 hover:text-white hover:bg-green-600 hover:border-transparent focus:outline-none focus:ring-2 focus:ring-purple-600 focus:ring-offset-2">ระบุจำนวน (บาท)
                <br>
                <input type="number" v-model="input_money" class="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" placeholder=""/>
                </button>     
              </div>
            </div>
            <div v-if="serverError.money"  class="flex flex-wrap items-center justify-around w-full text-sm text-red-500">
              {{serverError.money[0]}}
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end flex-shrink-0 p-4 border-t border-gray-200 modal-footer rounded-b-md">
            <div class="w-full">
              <button @click=" logedIn ? insertTocart() : insertTocartWithoutLogin()" 
                :disabled="disabled"
                :class="{'opacity-50 cursor-not-allowed': disabled}"
                class="block w-full px-4 py-2 mt-4 text-sm font-medium leading-5 text-center text-white transition-colors duration-150 bg-orange-600 border border-transparent rounded-lg cursor-pointer active:bg-purple-600 hover:bg-orange-500">
                <i class="fas fa-shopping-basket"></i> ชำระเงิน
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- \.ฟอร์มระบุจำนวนเงิน -->

    <!-- ฟอร์มแจ้งเตือนให้เข้าสู่ระบบ -->
    <div class="fixed top-0 left-0 hidden w-full h-full overflow-x-hidden overflow-y-auto outline-none modal fade" id="loginAlertModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="relative w-auto pointer-events-none modal-dialog modal-dialog-scrollable modal-lg">
        <div class="relative flex flex-col w-full text-current bg-white border-none rounded-md shadow-lg outline-none pointer-events-auto modal-content bg-clip-padding">
          <div
            class="flex items-center justify-between flex-shrink-0 p-4 border-b border-gray-200 modal-header rounded-t-md">
            <h5 class="text-xl font-medium leading-normal text-gray-800" id="exampleModalLabel">เข้าสู่ระบบ
            </h5>
            <button type="button"
              class="box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 btn-close focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="relative p-4 modal-body">
            เข้าสู่ระบบ หรือ ลงทะเบียนสมาชิก
            <!-- บริจาค เพื่อสะสมคะแนน CUCI-POINT และรับ Gift voucher หากท่านไม่ต้องการใช้สิทธิ์นี้  กดข้าม -->
          </div>
          <div class="flex flex-wrap items-center justify-end flex-shrink-0 p-4 border-t border-gray-200 modal-footer rounded-b-md">
            <!-- <button type="button" class="px-6 py-2.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out" data-bs-dismiss="modal">ข้าม</button> -->
            <router-link to="login">
              <button type="button" class="px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1" data-bs-dismiss="modal">เข้าสู่ระบบ / ลงทะเบียน</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- \.ฟอร์มแจ้งเตือนให้เข้าสู่ระบบ -->

</template>

<script>
    import http from '@/services/AuthService'
    import filter from '@/helpers/filter'
    import Cookies from 'js-cookie'
    export default {
        mounted(){
            this.retreiveProject(true)
            window.scrollTo({top: 0, behavior: 'smooth'});
            localStorage.setItem('lastVisit', 'Donate');
        },
        data(){
            return{
                projects: [],
                id: '',
                project_id: '',
                money: '',
                input_money: '',
                serverError: {},
                disabled: false,
                showModal: false,
                budget_type: '',
                set_amount: [],
                fee: '',
                project_category_id: 'all',
                is_fundraising: '',
            }
        },
        computed: {
          logedIn(){
            return this.$store.getters['authMember/logedIn']
          },
          myCart(){
            return this.$store.getters['authMember/cart']
          }
        },
        watch:{
          input_money: function(){
            this.money = this.input_money
          },
          project_category_id: function(){
            this.retreiveProject(true)
          },
          is_fundraising: function(){
            if(this.is_fundraising){
              this.$refs.fundingInProgress.classList.add('text-blue-600')
              this.$refs.cloasedFunding.classList.remove('text-blue-600')
            }else{
              this.$refs.fundingInProgress.classList.remove('text-blue-600')
              this.$refs.cloasedFunding.classList.add('text-blue-600')
            }
          }
        },
        methods:{
          selectCategory(project_category_id){
            this.project_category_id = project_category_id
            this.is_fundraising = true
          },
          insertTocartWithoutLogin(){
            if(this.money == ''){
              this.serverError = {
                money: ['กรุณาระบุจำนวนเงิน']
              }
            }else if(this.money > 10000){
              this.serverError = {
                money: ['จำนวนเงินต้องไม่เกิน 10,000 บาท']
              }
            }else{
              let currentCart = Cookies.get('cart_items');
              if(currentCart == undefined){
                let item = {
                  id: this.id,
                  money: this.money,
                  budget_type: this.budget_type
                }
                Cookies.set('cart_items', JSON.stringify([item]), {expires: 1})
              }else{
                let currentCart = JSON.parse(Cookies.get('cart_items'))
                //if cart_items have id equal 1 then delete it
                currentCart = currentCart.filter(item => item.id != 1)
                let item = currentCart.find(item => item.id == this.id && item.budget_type == this.budget_type)
                if(item == undefined){
                  let item = {
                    id: this.id,
                    money: this.money,
                    budget_type: this.budget_type
                  }
                  currentCart.push(item)
                }else{
                  item.money = this.money
                }
                Cookies.set('cart_items', JSON.stringify(currentCart), { expires: 1})
              }
              // console.log(JSON.parse(Cookies.get('cart_items')))
              this.$store.dispatch("authMember/retreiveCartWithoutLogin", JSON.parse(Cookies.get('cart_items')))
              this.showModal = false
              this.$store.dispatch("authMember/changeBackdrop")
              this.$router.push({name: 'Cart'})
            }
          },
          feeColculate(amount){
            //2.5 percent of the total amount
            return (this.fee/100) * amount
          },
          netColculate(amount){
            let feeRate = (this.fee/100) * amount
            return amount - feeRate
          },
          insertTocart(){
            this.disabled = true
            let data = new FormData()
            data.append('project_id', this.project_id)
            data.append('money', this.money)
            data.append('budget_type', this.budget_type)
            http.post(`donate/insertToCart`, data)
              .then(() => {
                this.money = ''
                this.$store.dispatch("authMember/retreiveCart")
                this.showModal = false
                this.$store.dispatch("authMember/changeBackdrop")
                const Toast = this.$swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 1000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                  },
                });

                Toast.fire({
                  icon: "success",
                  title: "เพิ่มเข้าตะกร้าเรียบร้อย",
                })
                
                this.$router.push({name: 'Cart'})
                this.disabled = false
                this.serverError = {}
              })
              .catch(error => {
                if(error.response.status == 401 || error.response.status == 419){ //ถ้า token หมดอายุ
                    this.$store.dispatch('authMember/unauthenticateResetting')
                  }  
                this.disabled = false
                this.serverError = error.response.data.errors
              })
          },
          closeModal(){
            this.showModal = false
            this.$store.dispatch("authMember/changeBackdrop")  
          },
          selectProject(project_id, budget_type, set_amount, fee, id, project_process){
            if(project_process != 5){
              this.project_id = project_id
              this.budget_type = budget_type
              this.set_amount = set_amount
              this.id = id
              this.fee = fee
              this.money = ''
              this.input_money = ''
              this.showModal = true
              this.$store.dispatch("authMember/changeBackdrop")
            }
          },
          selectMoney(money){
            this.money = money
            this.input_money = ''
          },
          retreiveProject(is_fundraising){
            this.$Progress.start()
            this.is_fundraising = is_fundraising
            http.get(`frontendProject/projects/${this.project_category_id}/${is_fundraising}`)
                .then(response => {
                    this.projects = response.data.projects.data.map((item) => {
                        return Object.assign(item, {image: process.env.VUE_APP_URL_COOKIE+'images/project/banner/'+item.banner})
                    })
                    this.$Progress.finish()
                })
                .catch(error => {
                  if(error.response.status == 401 || error.response.status == 419){ //ถ้า token หมดอายุ
                    this.$store.dispatch('authMember/unauthenticateResetting')
                  }
                  this.$Progress.fail()
                })
          },
          showMoney(money){
              return filter.numberFormat(money, '0,0.00')
          },
          showAmount(money){
                return filter.numberAmount(money, '0,0')
            },
        },
    }
</script>

<style lang="css" scoped>
  .show-modal{
    display: block;
  }
  .hide-modal{
    display: none;
  }
</style>